import SvgIcon from "../../components/SvgIcon/SvgIcon";

const SupplierFormPlaceholder = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 opacity-80">
      {/* Ícono */}
      <SvgIcon name="store" className="w-16 h-16 text-primary mb-4" />

      {/* Título */}
      <h3 className="text-gray-800 dark:text-gray-200 text-xl font-semibold mb-2">
        Datos del Proveedor
      </h3>

      {/* Texto descriptivo */}
      <p className="text-gray-600 dark:text-gray-400 max-w-lg text-sm leading-relaxed">
        Selecciona el tipo de entidad para visualizar los campos requeridos.
        Completa la información necesaria para registrar correctamente al proveedor
        dentro del sistema.
      </p>
    </div>
  );
};

export default SupplierFormPlaceholder;
